export const TOKEN_KEY = "@airbnb-Token";
export const USER_ID = "@nooio";

interface LoginProps {
  token: string;
  user_id: string;
};

interface LogoutProps {
  redirect?: boolean;
}

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getUserId = () => localStorage.getItem(USER_ID);

export const login = ({
  token,
  user_id
}: LoginProps) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_ID, user_id);
};

export const logout = ({ redirect = true }: LogoutProps) => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_ID);

  if (redirect) window.location.href = '/';
};
